import { cn } from "@/libraries/cn";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography } from "../text";

interface LoadingProps {
	status?: boolean;
	title?: string;
	message?: string;
}

const Loading: React.FC<LoadingProps> = ({ status, title, message }) => {
	return (
		<>
			<Box
				className={cn("w-screen h-dvh fixed inset-0 z-[9999]", {
					"flex flex-col justify-center items-center": status,
					hidden: !status,
					"bg-white": title || message,
					"bg-dark/45": !title && !message,
				})}
			>
				<div className="flex flex-col gap-3 justify-center items-center">
					<CircularProgress />
					{title ? (
						<Typography fontWeight={700} fontSize={16}>
							{title}
						</Typography>
					) : null}
					{message ? (
						<Typography fontWeight={400} fontSize={14}>
							{message}
						</Typography>
					) : null}
				</div>
			</Box>
		</>
	);
};

export default Loading;
